import Axios from 'axios';
import AccessToken from './AccessToken';
import AgentId from './AgentId';
const moment = require('moment-timezone');


export default {
  accessToken        : AccessToken,
  agentId            : AgentId,
  queryStack         : {},
  maxResendTriesCount: 5,
  options            : {
    baseURL: `${process.env.VUE_APP_API_URL}/`,
    headers: {
      'X-Timezone'       : moment && moment.tz ? moment.tz.guess() : null,
      'X-Timezone-Offset': (new Date().getTimezoneOffset()),
    },
  },

  get(url, params = {}) {
    this.setAuthBearer();
    const { options } = this;
    options.url = url;
    options.method = 'GET';
    options.params = params;

    return this.sendQuery(options);
  },

  delete(url, params = {}) {
    this.setAuthBearer();

    const { options } = this;
    options.url = url;
    options.method = 'DELETE';
    options.params = params;

    return this.sendQuery(options);
  },

  post(url, data = {}, params = {}) {
    this.setAuthBearer();

    const { options } = this;
    options.url = url;
    options.method = 'POST';
    options.data = data;
    options.params = params;

    return this.sendQuery(options);
  },

  patch(url, data = {}, params = {}) {
    this.setAuthBearer();

    const { options } = this;
    options.url = url;
    options.method = 'PATCH';
    options.data = data;
    options.params = params;

    return this.sendQuery(options);
  },

  put(url, data = {}, params) {
    this.setAuthBearer();

    const { options } = this;
    options.url = url;
    options.method = 'PUT';
    options.data = data;
    options.params = params;

    return this.sendQuery(options);
  },

  generateUUID(options) {
    return options.url + JSON.stringify(options.params) + JSON.stringify(options.data ? options.data : {});
  },

  sendQuery(options) {
    const queryOptions = Object.assign({}, options);
    queryOptions.uuid = this.generateUUID(queryOptions);
    queryOptions.url = encodeURI(queryOptions.url);

    if (queryOptions.params && queryOptions.params.responseType) {
      queryOptions.responseType = queryOptions.params.responseType;
    }

    const axiosInstance = Axios.create();
    return axiosInstance.request(queryOptions)
      .then((response) => {
        return response;
      })
      .catch((errors) => {
        delete this.queryStack[queryOptions.uuid];

        return this.tryResolveErrors(errors, queryOptions.url, queryOptions.data ? queryOptions.data : {}, queryOptions.params, queryOptions.method);
      })
      .finally(() => {
        delete this.queryStack[queryOptions.uuid];
      });
  },

  setAuthBearer() {
    const _token = AccessToken.get();
    if (_token) {
      this.options.headers.Authorization = `Bearer ${_token}`;
      this.options.headers['User-Agent-Id'] = AgentId.get();
    } else {
      delete this.options.headers.Authorization;
    }
  },

  tryResolveErrors(errors, url, data = {}, params = {}, type) {
      let accessToken = this.accessToken.get();
      if (!!accessToken && errors.response.status === 401) {
          let options = this.options;
          options.url = "/auth/refresh";
          options.method = 'POST';
          options.params = null;

          return Axios(options).then(response => {
              this.accessToken.set(response.data.access_token);
              switch (type) {
                  case "GET":
                      return this.get(url, params);
                  case "POST":
                      return this.post(url, data, params);
                  case "PATCH":
                      return this.patch(url, data, params);
                  case "DELETE":
                      return this.delete(url, params);
                  case "PUT":
                      return this.put(url, params);
              }
          }).catch(errors => {
              this.accessToken.clear();
              location.reload();
              return errors.response.data;
          });
      } else {
          return errors.response.data;
      }
  },
};
